import React, { useState } from "react";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import { pdfjs } from 'react-pdf';
import "./pdf.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function AllPagesPDFViewer(props: { pdf: string; width?: number }) {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [error, setError] = useState(false);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
    setError(false);
  }

  const { pdf, width } = props;
  if (!pdf) return null;

  const fileSource = pdf.startsWith('data:')
    ? pdf
    : `data:application/pdf;base64,${pdf}`;

  if (error) {
    return (
      <div style={{ padding: 16, color: '#888', textAlign: 'center' }}>
        Unable to load PDF. <a href={fileSource} target="_blank" rel="noreferrer" style={{ color: '#007bff' }}>Download instead</a>
      </div>
    );
  }

  return (
    <Document
      file={fileSource}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={() => setError(true)}
      className="bg-body-tertiary"
      loading={<div style={{ padding: 16, color: '#888', textAlign: 'center' }}>Loading PDF...</div>}
    >
      {numPages && Array.from(new Array(numPages), (_el, index) => (
        <Page key={`page_${index + 1}`} pageNumber={index + 1} width={width} />
      ))}
    </Document>
  );
}
